export default __webpack_public_path__ + "static/media/0x282d8efce846a88b159800bd4130ad77443fa1a1.9fc23243.png";